import React, { useEffect, useState } from "react";

import WithAsync from "../components/with-async";

import { Select } from "../inputs";
import { SelectedItem } from "../shared/selected-item";
//import Dropdown from '../typeahead/components/dropdown';
import { useInput } from "../../../shared/hooks/form-fields";
import { WithLabel } from "../components/with-label";
import { checkMultiMatch } from "../typeahead/lib/check-match";

// ComponentType: MultiDropdownPicklist

const filterUsed = (options, values) => {
    const listOfValues = values.map((o) => o.value);

    const filteredOptions = options.reduce((opts, o) => {
        if (!listOfValues.includes(o.value)) {
            opts.push(o);
        }

        return opts;
    }, []);

    return filteredOptions;
};

const MultiSelect = (props) => {
    const selectInput = useInput("");
    const [multiValue, setMultiValue] = useState(props.value || props.defaultValue || []);
    const [options, setOptions] = useState(props.options);

    useEffect(() => {
        setOptions(filterUsed(props.options, multiValue));
    }, [props.options]);

    useEffect(() => {
        const defaultValue = props.value || props.defaultValue || [];
        const isMatch = checkMultiMatch(defaultValue, multiValue);

        if (!isMatch) {
            setMultiValue(defaultValue);
        }
    }, [props.value, props.defaultValue]);

    useEffect(() => {
        setOptions(filterUsed(props.options, multiValue));
        props.updateOnChange(props.name, multiValue);
    }, [multiValue]);

    const onClickAdd = (e) => {
        const fullValue = options.find((o) => String(o.value) === String(selectInput.value));
        const newOptions = options.filter((o) => o.value !== selectInput.value);

        if (fullValue) {
            setMultiValue([...multiValue, { ...fullValue }]);
            setOptions(newOptions);
        }

        selectInput.reset();
    };

    const removeValue = (value) => {
        const withRemoved = multiValue.filter((v) => v.value !== value);

        setMultiValue(withRemoved);
    };

    const selected =
        multiValue && multiValue.length > 0
            ? multiValue.map((obj, index) => {
                  return <SelectedItem key={`${obj.value}_${index}`} value={obj.value} text={obj.text} removeValue={(i) => removeValue(obj.value)} disabled={props.disabled} />;
              })
            : null;

    return (
        <div>
            <div>{selected}</div>
            <div className="input-group -no-margin">
                <Select name={props.name} options={options} {...selectInput.bind} excludeSelect={props.excludeSelect} disabled={props.disabled} />
                {!props.disabled && (
                    <button className="button -primary" onClick={onClickAdd}>
                        +
                    </button>
                )}
            </div>
        </div>
    );
};

MultiSelect.defaultProps = {
    options: [],
};

export default WithLabel(WithAsync(MultiSelect));
